import { ChakraProvider } from '@chakra-ui/react'

// import { useNavigateLogger } from 'BrokerTsLib/src/hooks'
import { BrandingSwitcher } from './BrandingSwitcher'
import { Footer } from './containers/Footer'
import { useCustomTheme } from './context/CustomThemeContext'
import { Router } from './Router'

export const App = () => {
  const { customTheme, onThemeChange } = useCustomTheme()

  // zaloguje do console zmeny pri navigaci
  //useNavigateLogger()

  return (

    <ChakraProvider theme={customTheme}>
      <Router />
      <BrandingSwitcher />
      <Footer />
      {/* <ThemeSwitcher onThemeChange={onThemeChange} /> */}
    </ChakraProvider>

  )
}

export default App

